import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faArrowRight, faTimes } from '@fortawesome/free-solid-svg-icons';
import { PopPosition } from '@nirby/js-utils/embed';

@Component({
    selector: 'nirby-large-popper',
    templateUrl: './large-popper.component.html',
    styleUrls: ['./large-popper.component.scss'],
})
export class LargePopperComponent {
    @Input() position: PopPosition = 'BOTTOM-LEFT-CORNER';
    @Input() backgroundUrl: string | null = null;
    @Input() body = '';
    @Input() label = '';
    @Input() showCloseButton = true;

    @Output() closed = new EventEmitter();
    @Output() popped = new EventEmitter();

    iconClose = faTimes;
    iconArrowRight = faArrowRight;
}
